import request from '@/utils/request'

// 查询定制订单管理列表
export function listOrder(query) {
  return request({
    url: '/server/order/list',
    method: 'post',
    data: query
  })
}

// 提交订单
export function addOrder(data) {
  return request({
    url: '/server/order/add',
    method: 'post',
    data: data
  })
}

// 查询定制订单管理详细
export function getOrder(appId) {
  return request({
    url: '/server/order/' + appId,
    method: 'get'
  })
}

// 修改定制订单管理
export function updateOrder(data) {
  return request({
    url: '/server/order',
    method: 'put',
    data: data
  })
}

// 删除定制订单管理
export function delOrder(appId) {
  return request({
    url: '/server/order/' + appId,
    method: 'delete'
  })
}

// 取消订单
export function cancel(data) {
  return request({
    url: '/server/order/cancel',
    method: 'put',
    data: data
  })
}


// 查询定制订单管理列表
export function details(id) {
  return request({
    url: '/server/order/details/' + id,
    method: 'get',
  })
}



// 订单加急
export function createShip(data) {
  return request({
    url: '/server/order/ship/create',
    method: 'post',
    data: data
  })
}

// 结算页面查询支持的物流方式
export function getShip(data) {
  return request({
    url: '/server/order/cart/ship',
    method: 'post',
    data: data
  })
}


// 结算页面查询支持的物流方式
export function getOrderShip(data) {
  return request({
    url: '/server/order/ship',
    method: 'post',
    data: data
  })
}
// 结算页面查询支持的物流方式
export function getTrackInfo(data) {
  return request({
    url: '/server/order/trackInfo',
    method: 'GET',
    params: data
  })
}


